import { numericValueFormat, percentFormat } from "../graphs/common"
import { useCallback } from "react"
import { toolTipMargin } from "../../../constants"

type useTooltipProps = {
	trigger: 'item' | 'axis'
	valueDef?: {
		unit?: string
	},
	is100?: boolean
}
export const useTooltip = ({
	trigger,
	valueDef,
	is100
}: useTooltipProps) => {
  const valueFormatter = useCallback(
    (value: number | string) => {
      if (value === undefined || value === null) return ''
      if (is100) {
        if (typeof value === 'number') return percentFormat(null, value * 100, 1)
        return ''
      }
			return numericValueFormat(value, 1, valueDef?.unit)
		},
    [valueDef, is100]
  )
  const position = useCallback(
    (pos: number[], params: unknown, dom: unknown, rect: unknown, size: { viewSize: number[], contentSize: number[] }) => {
      const left = Math.max(toolTipMargin.y, Math.min(size.viewSize[0] - (size.contentSize[0] + toolTipMargin.y), 
        (pos[0] < size.viewSize[0] / 2) ? (pos[0] + toolTipMargin.x) : (pos[0] - (size.contentSize[0] + toolTipMargin.x))
      ))
      const top = Math.max(toolTipMargin.y, Math.min(size.viewSize[1] - (size.contentSize[1] + toolTipMargin.y), 
        (pos[1] < size.viewSize[1] / 2) ? (pos[1] + toolTipMargin.y) : (pos[1] - (size.contentSize[1] + toolTipMargin.y))
      ))
      return { top, left }
    },
    []
  )
	return {
		trigger,
		axisPointer: {
			type: 'shadow',
		},
		valueFormatter,
		position,
    containLabel: true
	}
}